import {
	getConfigValue,
	initRemoteConfig,
} from '../services/remoteConfig.service';
import { useEffect } from 'react';

// Initialises remote config on mount and exposes getValue(key).
// Components should call getValue(key) after mount — values are available
// once initRemoteConfig() resolves (typically within the first render cycle).
export const useRemoteConfig = () => {
	useEffect(() => {
		initRemoteConfig();
	}, []);

	return { getValue: getConfigValue };
};
